import { UserCredential, onAuthStateChanged } from "firebase/auth";
import AdminAccount from "../model/auth/AdminAccount"
import { makeAutoObservable, action, runInAction } from 'mobx';
import { signOutFromFirebase } from "../service/AuthService";
import CryptoJS from 'crypto-js';
import { auth } from "../common/firebase/Firebase";

const ENCRYPTION_KEY = 'xL93bVtQ7eN1zJHpRfYK2wXmuADgEcTI';

class AuthStore {
    user: AdminAccount | null = null;
    userCredential: UserCredential | null = null;
    userIdToken: string | null = null;

    /// 비밀번호 변경을 위한 임시 인증
    changePasswordVerificationId: string | null = null;


    constructor() {
        makeAutoObservable(this, {
            logout: action,
        }); // MobX 상태 자동 설정
        this.loadLoginState(); // 초기화 시 로그인 상태 로드
        this.setupAuthStateListener(); // Firebase auth 상태 변화 감지
    };

    setupAuthStateListener() {
        onAuthStateChanged(auth, (user) => {
            if (user === null) {
                // 사용자가 로그아웃되었거나 세션이 만료된 경우
                runInAction(() => {
                    this.user = null;
                    this.userCredential = null;
                    this.userIdToken = null;
                    localStorage.removeItem('userIdToken');
                });
            }
        });
    }

    setLogin(user: AdminAccount, userCredential: UserCredential, userIdToken: string) {
        this.user = user;
        this.userCredential = userCredential;
        this.userIdToken = userIdToken;

        this.saveLoginState();
        this.saveUserState();
    };

    setIdToken(userIdToken: string) {
        this.userIdToken = userIdToken;

        this.saveLoginState();
    };

    saveChangePasswordVerificationId(verificationId: string) {
        sessionStorage.setItem('changePasswordVerificationId', JSON.stringify(verificationId));
    }

    saveLoginState() {
        localStorage.setItem('userIdToken', JSON.stringify(this.userIdToken)); // 상태를 저장
    };

    saveUserState() {
        const encryptedUser = CryptoJS.AES.encrypt(JSON.stringify(this.user), ENCRYPTION_KEY).toString();
        localStorage.setItem('user', encryptedUser);
    }

    getIdToken(): string | null {
        /// userIdToken이 없을 경우 Local Storage에서 찾아본다.
        if (!this.userIdToken) {
            this.loadLoginState();
        }
        
        return this.userIdToken;
    };

    loadUserState() {
        const userCipher = localStorage.getItem('user');

        if (userCipher) {
            const decryptedUserStr = CryptoJS.AES.decrypt(userCipher, ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8);
            const user: AdminAccount = JSON.parse(decryptedUserStr);
            this.user = user;
        }
    }

    getChangePasswordVerificationId(): string | null {
        const savedVerificationId = sessionStorage.getItem('changePasswordVerificationId');
        if (savedVerificationId !== null) {
            return JSON.parse(savedVerificationId); // 저장된 상태를 로드
        } else {
            return null;
        }
    }

    resetChangePasswordVerificationId() {
        sessionStorage.removeItem('changePasswordVerificationId');
    }

    loadLoginState() {
        const savedState = localStorage.getItem('userIdToken');
        if (savedState !== null) {
            this.userIdToken = JSON.parse(savedState); // 저장된 상태를 로드
        }
    };

    async logout() {
        try {
            await signOutFromFirebase();
        } catch (e) {
            console.error("Firebase Sign Out 실패: ", e);
        }

        runInAction(() => {
            this.user = null;
            this.userCredential = null;
            this.userIdToken = null;
    
            localStorage.removeItem('userIdToken');
        });
    };
};

export const authStore = new AuthStore();